import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ImageManager from '@/script/ImageManager';
import TextManager from '@/script/TextManager';
import ExhibitorManager from '@/script/ExhibitorManager';
import GimmickManager from '@/script/GimmickManager';
import store from '@/store';

Vue.config.productionTip = false;

setTimeout(async () => {
  await ImageManager.INSTANCE.init();
  await TextManager.INSTANCE.init();
  await ExhibitorManager.INSTANCE.init();
  await GimmickManager.INSTANCE.init();

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
